<section *ngIf="posts$ | async as posts" class="w-full mt-[133px] flex flex-col items-center">
    <img src="images/landing/the-blog.svg" alt="blog" class="h-[40px] mb-[18px]" />
    <app-post-carousel class="show-web" [postsRaw]="posts"></app-post-carousel>
    <app-post-carousel-mobile class="show-mobile" [postsRaw]="posts"></app-post-carousel-mobile>
    <app-button (clicked)="goToBlog()" class="mt-[50px]" buttonText="view all"></app-button>
</section>